  export const addVariable = ({variables, intent, updateVariables, updateIntent}) => {
    variables.push({
      variable: "",
      equivalence: [],
      zendesk_ticket_field: {
        desk_id: null,
        id: null,
        title: "",
        type: "",
        equivalences: [],
        custom_field_options: [],
        custom_field_options_actual: [],
      },
    });
    updateVariables(variables);
    updateIntent(intent);
  };